// Reconnect timing for the live channel: an exponential window (1s, 2s, 4s, … capped at
// 30s) with the wait drawn from its upper half, so a deploy that drops every tab at once
// doesn't bring them all back in the same instant.

const BASE_DELAY_MS = 1000;
const MAX_DELAY_MS = 30000;

export const nextRetryDelay = (previousRetryCount, random = Math.random) => {
  const ceiling = Math.min(MAX_DELAY_MS, BASE_DELAY_MS * 2 ** previousRetryCount);
  return Math.round(ceiling / 2 + random() * (ceiling / 2));
};
